
import React, { createContext, useContext, ReactNode, useCallback, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import { locationState } from './locationState';

interface LocationContextType {
  userLocation: any;
  setUserLocation: (location:any) => void;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [locationStateValue, setLocationState] = useRecoilState(locationState);

  // Extract the actual userLocation from the state object
  const userLocation = locationStateValue?.userLocation || null;
  
  // Wrapper function to set userLocation properly in the state structure
  const setUserLocation = useCallback((location: any) => {
    setLocationState((prev: any) => {
      const prevLocation = prev?.userLocation;

      if (
        prevLocation?.latitude === location?.latitude &&
        prevLocation?.longitude === location?.longitude &&
        prevLocation?.name === location?.name &&
        prevLocation?.city === location?.city
      ) {
        return prev;
      }

      return { userLocation: location };
    });
  }, [setLocationState]);

  const value = useMemo(
    () => ({ userLocation, setUserLocation }),
    [userLocation, setUserLocation]
  );

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

export const useUserLocation = (): LocationContextType => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('userLocation must be used within a LocationProvider');
  }
  return context;
};
